export default "__VITE_ASSET__DiJekl2f__"